// AI: justified because the generated client (`@app/api-client/generated`) is not
// available until `pnpm api:generate` has been run at least once. After the first
// generation, this file MUST be deleted and the generated hooks used instead.

import { apiAxios } from '@app/api-client';
import type { AuthResponse, SetupInitializeInput, SetupStatus } from '@app/contracts';

export const fetchSetupStatus = (): Promise<SetupStatus> =>
  apiAxios<SetupStatus>({ url: '/api/v1/setup/status', method: 'GET' });

export const initializeSetup = (input: SetupInitializeInput): Promise<AuthResponse> =>
  apiAxios<AuthResponse>({ url: '/api/v1/setup/initialize', method: 'POST', data: input });
